function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, objectSpread2 as _objectSpread2, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import { reaction, observable, action, computed } from 'mobx';
import AnnotationField, { getFieldData } from "./AnnotationField.js";
import "../types/index.js";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _class2, _temp;

function positionComparator(first, second) {
  var yDiff = first.y - second.y;
  var yDiffMagnitude = Math.abs(yDiff);
  var lineHeight = yDiff < 0 ? first.height : second.height;
  var onSameLine = yDiffMagnitude < lineHeight;
  if (!onSameLine) return yDiff;
  return first.x - second.x;
}

var PdfPageStore = (_class = (_temp = _class2 = /*#__PURE__*/function () {
  function PdfPageStore(pdfDocumentStore, pageNumber, fields) {
    var _this = this;

    _classCallCheck(this, PdfPageStore);

    this.pageNumber = void 0;
    this.pdfStore = void 0;
    this.pdfDocumentStore = void 0;

    _initializerDefineProperty(this, "fields", _descriptor, this);

    _initializerDefineProperty(this, "pageProxy", _descriptor2, this);

    _initializerDefineProperty(this, "width", _descriptor3, this);

    _initializerDefineProperty(this, "height", _descriptor4, this);

    _initializerDefineProperty(this, "ghostFields", _descriptor5, this);

    _initializerDefineProperty(this, "multiSelectBox", _descriptor6, this);

    _initializerDefineProperty(this, "renderPageIfOutOfView", _descriptor7, this);

    this.unScale = function (value) {
      return Math.round(value / _this.pdfDocumentStore.scale);
    };

    this.generateFields = function (currentMouseLocation) {
      var _this$pdfStore$assign;

      if (_this.pdfStore.copiedFields) {
        return _this.generateFieldCopies(currentMouseLocation);
      }

      if (!_this.pdfStore.drawMode) return undefined;
      var data = getFieldData(_this.pdfStore.drawMode);

      if (data.dataType === 'autofill') {
        var options = _this.pdfStore.mergeFieldOptions;
        var firstOptionData = options[0].value || options[0].options[0].value;
        data = _objectSpread2(_objectSpread2({}, data), firstOptionData);
      }

      var fieldWidth = data.defaultWidth;
      var fieldHeight = data.defaultHeight;
      var halfFieldWidth = fieldWidth / 2;
      var halfFieldHeight = fieldHeight / 2;
      var fieldX = _this.unScale(currentMouseLocation.x) - halfFieldWidth;
      var fieldY = _this.unScale(currentMouseLocation.y) - halfFieldHeight;

      var _this$limitFieldPosit = _this.limitFieldPositionToPageBoundary({
        x: fieldX,
        y: fieldY
      }, fieldWidth, fieldHeight),
          x = _this$limitFieldPosit.x,
          y = _this$limitFieldPosit.y;

      return [new AnnotationField({
        x: x,
        y: y,
        width: fieldWidth,
        height: fieldHeight,
        page: _this.pageNumber,
        data: _objectSpread2(_objectSpread2({}, data), {}, {
          assignedTo: (_this$pdfStore$assign = _this.pdfStore.assignmentStore.defaultOption) === null || _this$pdfStore$assign === void 0 ? void 0 : _this$pdfStore$assign.assignmentKey
        })
      })];
    };

    this.generateFieldCopies = function (currentMouseLocation) {
      var copiedFields = _this.pdfStore.copiedFields;
      if (!copiedFields) return undefined;
      var updatedPositions = [];
      var newAnnotationFields = [];
      var avgX = 0;
      var avgY = 0;
      copiedFields.forEach(function (field) {
        var halfFieldWidth = field.width / 2;
        var halfFieldHeight = field.height / 2;
        avgX += field.x + halfFieldWidth;
        avgY += field.y + halfFieldHeight;
      });
      avgX /= copiedFields.length;
      avgY /= copiedFields.length;
      var xBoundLimit = 0;
      var yBoundLimit = 0; // When copying multiple fields, if one of the fields is blocked by the boundary
      // then all of the fields need to be blocked by that amount

      copiedFields.forEach(function (field) {
        var halfFieldWidth = field.width / 2;
        var halfFieldHeight = field.height / 2;
        var xOffset = field.x + halfFieldWidth - avgX;
        var yOffset = field.y + halfFieldHeight - avgY;
        var copiedFieldX = _this.unScale(currentMouseLocation.x) - halfFieldWidth + xOffset;
        var copiedFieldY = _this.unScale(currentMouseLocation.y) - halfFieldHeight + yOffset;

        var _this$limitFieldPosit2 = _this.limitFieldPositionToPageBoundary({
          x: copiedFieldX,
          y: copiedFieldY
        }, field.width, field.height),
            x = _this$limitFieldPosit2.x,
            y = _this$limitFieldPosit2.y;

        xBoundLimit = Math.abs(xBoundLimit) > Math.abs(x - copiedFieldX) ? xBoundLimit : x - copiedFieldX;
        yBoundLimit = Math.abs(yBoundLimit) > Math.abs(y - copiedFieldY) ? yBoundLimit : y - copiedFieldY;
        updatedPositions.push({
          x: copiedFieldX,
          y: copiedFieldY
        });
      });
      copiedFields.forEach(function (field, index) {
        newAnnotationFields.push(new AnnotationField(_objectSpread2(_objectSpread2({}, field), {}, {
          id: undefined,
          data: _objectSpread2(_objectSpread2({}, field.data), {}, {
            id: undefined
          }),
          x: updatedPositions[index].x + xBoundLimit,
          y: updatedPositions[index].y + yBoundLimit,
          page: _this.pageNumber
        })));
      });
      return newAnnotationFields;
    };

    this.limitFieldPositionToPageBoundary = function (fieldLocation, fieldWidth, fieldHeight) {
      var minX = 0;
      var maxX = _this.width - fieldWidth;
      var minY = 0;
      var maxY = _this.height - fieldHeight;
      var x = Math.min(maxX, Math.max(fieldLocation.x, minX));
      var y = Math.min(maxY, Math.max(fieldLocation.y, minY));
      return {
        x: x,
        y: y
      };
    };

    this.minWidthForSelectedField = function () {
      var _this$pdfStore$select, _this$pdfStore$select2;

      var valueType = (_this$pdfStore$select = _this.pdfStore.selectedField) === null || _this$pdfStore$select === void 0 ? void 0 : (_this$pdfStore$select2 = _this$pdfStore$select.data) === null || _this$pdfStore$select2 === void 0 ? void 0 : _this$pdfStore$select2.valueType;

      if (valueType === 'signature') {
        return PdfPageStore.MIN_SIGNATURE_FIELD_WIDTH;
      } else if (valueType === 'initials') {
        return PdfPageStore.MIN_INITIALS_FIELD_WIDTH;
      }

      return PdfPageStore.MIN_FIELD_WIDTH;
    };

    _initializerDefineProperty(this, "drawField", _descriptor8, this);

    _initializerDefineProperty(this, "addField", _descriptor9, this);

    _initializerDefineProperty(this, "deleteField", _descriptor10, this);

    _initializerDefineProperty(this, "setPageProxy", _descriptor11, this);

    _initializerDefineProperty(this, "moveFieldToFront", _descriptor12, this);

    _initializerDefineProperty(this, "setDimensions", _descriptor13, this);

    _initializerDefineProperty(this, "setGhostFields", _descriptor14, this);

    _initializerDefineProperty(this, "setMultiSelectBox", _descriptor15, this);

    _initializerDefineProperty(this, "setRenderPageIfOutOfView", _descriptor16, this);

    _initializerDefineProperty(this, "updateDraggingFieldLocations", _descriptor17, this);

    _initializerDefineProperty(this, "updateResizingFieldDimensions", _descriptor18, this);

    _initializerDefineProperty(this, "updateMultiSelectBoxDimensions", _descriptor19, this);

    _initializerDefineProperty(this, "selectFieldsInMultiSelectBox", _descriptor20, this);

    _initializerDefineProperty(this, "updateGhostFieldLocations", _descriptor21, this);

    _initializerDefineProperty(this, "updateSelectedFieldLocation", _descriptor22, this);

    _initializerDefineProperty(this, "moveSelectedFields", _descriptor23, this);

    this.pdfDocumentStore = pdfDocumentStore;
    this.pdfStore = pdfDocumentStore.pdfStore;
    this.pageNumber = pageNumber;
    this.fields = fields.sort(positionComparator);
    reaction(function () {
      return _this.fields.map(function (field) {
        return field.data;
      });
    }, function () {
      _this.pdfStore.setIsDataDirty(true);
    });
  }

  _createClass(PdfPageStore, [{
    key: "contextMenu",
    get: function get() {
      var menu = this.pdfStore.contextMenu;
      return (menu === null || menu === void 0 ? void 0 : menu.page) === this.pageNumber ? menu : undefined;
    }
  }]);

  return PdfPageStore;
}(), _class2.MIN_FIELD_WIDTH = 10, _class2.MIN_SIGNATURE_FIELD_WIDTH = 100, _class2.MIN_INITIALS_FIELD_WIDTH = 30, _class2.MIN_FIELD_HEIGHT = 10, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "fields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pageProxy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "width", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "height", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "ghostFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multiSelectBox", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "renderPageIfOutOfView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "drawField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (currentMouseLocation) {
      var newFields = _this2.generateFields(currentMouseLocation);

      if (!newFields) return;

      _this2.pdfStore.setSelectedFields();

      newFields.forEach(function (field) {
        _this2.addField(field);

        _this2.pdfStore.addSelectedField(field);
      });
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "addField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (field) {
      _this3.fields.push(field);
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "deleteField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (field) {
      _this4.fields.remove(field);
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setPageProxy", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (pageProxy) {
      _this5.pageProxy = pageProxy;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "moveFieldToFront", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (field) {
      _this6.deleteField(field);

      _this6.addField(field);
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "contextMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contextMenu"), _class.prototype), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "setDimensions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (width, height) {
      _this7.width = _this7.unScale(width);
      _this7.height = _this7.unScale(height);
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "setGhostFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (fields) {
      _this8.ghostFields = fields;
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "setMultiSelectBox", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (multiSelectBox) {
      _this9.multiSelectBox = multiSelectBox;
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "setRenderPageIfOutOfView", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;

    return function (renderPageIfOutOfView) {
      _this10.renderPageIfOutOfView = renderPageIfOutOfView;
    };
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "updateDraggingFieldLocations", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;

    return function (originalFieldLocations, mouseStart, currentMouse) {
      var _this$pdfStore$select3, _this$pdfStore$select4;

      var updatedPositions = [];
      var xBoundLimit = 0;
      var yBoundLimit = 0; // When dragging multiple fields, if one of the fields is blocked by the boundary
      // then all of the fields need to be blocked by that amount

      (_this$pdfStore$select3 = _this11.pdfStore.selectedFields) === null || _this$pdfStore$select3 === void 0 ? void 0 : _this$pdfStore$select3.forEach(function (field, index) {
        var updatedX = originalFieldLocations[index].x + _this11.unScale(currentMouse.x - mouseStart.x);

        var updatedY = originalFieldLocations[index].y + _this11.unScale(currentMouse.y - mouseStart.y);

        var _this11$limitFieldPos = _this11.limitFieldPositionToPageBoundary({
          x: updatedX,
          y: updatedY
        }, field.width, field.height),
            x = _this11$limitFieldPos.x,
            y = _this11$limitFieldPos.y;

        xBoundLimit = Math.abs(xBoundLimit) > Math.abs(x - updatedX) ? xBoundLimit : x - updatedX;
        yBoundLimit = Math.abs(yBoundLimit) > Math.abs(y - updatedY) ? yBoundLimit : y - updatedY;
        updatedPositions.push({
          x: updatedX,
          y: updatedY
        });
      });
      (_this$pdfStore$select4 = _this11.pdfStore.selectedFields) === null || _this$pdfStore$select4 === void 0 ? void 0 : _this$pdfStore$select4.forEach(function (field, index) {
        var newPosition = updatedPositions[index];
        field.updateAttributes({
          x: newPosition.x + xBoundLimit,
          y: newPosition.y + yBoundLimit
        });
      });
    };
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "updateResizingFieldDimensions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;

    return function (originalFieldLocAndDims, mouseStart, currentMouse) {
      var field = _this12.pdfStore.resizingField; // Determine updated field dimensions based on original dimensions and
      // mouse movement.

      var updatedWidth = originalFieldLocAndDims.width + _this12.unScale(currentMouse.x - mouseStart.x);

      var updatedHeight = originalFieldLocAndDims.height + _this12.unScale(currentMouse.y - mouseStart.y);

      var minWidth = _this12.minWidthForSelectedField();

      var maxWidth = _this12.width - originalFieldLocAndDims.x;
      var minHeight = PdfPageStore.MIN_FIELD_HEIGHT;
      var maxHeight = _this12.height - originalFieldLocAndDims.y;
      var width = Math.min(maxWidth, Math.max(updatedWidth, minWidth));
      var height = Math.min(maxHeight, Math.max(updatedHeight, minHeight)); // When resizing a manual text field across the 40px height threshold,
      // toggle the multiline attribute

      if (field.manualTextField) {
        if (height >= 40 && field.height < 40) {
          field.updateData({
            multiline: true
          });
        } else if (height < 40 && field.height >= 40) {
          field.updateData({
            multiline: false
          });
        }
      }

      field.updateAttributes({
        width: width,
        height: height
      });
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "updateMultiSelectBoxDimensions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;

    return function (mouseStart, currentMouse) {
      if (!_this13.multiSelectBox) return;
      var multiSelectBox = _this13.multiSelectBox; // Determine updated box dimensions based on mouse movement

      var updatedWidth = _this13.unScale(currentMouse.x - mouseStart.x);

      var updatedHeight = _this13.unScale(currentMouse.y - mouseStart.y);

      var maxWidth = _this13.width;
      var maxHeight = _this13.height;
      var width = Math.min(maxWidth, updatedWidth);
      var height = Math.min(maxHeight, updatedHeight);
      var x = width < 0 ? _this13.unScale(mouseStart.x) + width : multiSelectBox.x;
      var y = height < 0 ? _this13.unScale(mouseStart.y) + height : multiSelectBox.y;
      multiSelectBox.x = x;
      multiSelectBox.y = y;
      multiSelectBox.width = Math.abs(width);
      multiSelectBox.height = Math.abs(height);
    };
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "selectFieldsInMultiSelectBox", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;

    return function () {
      if (!_this14.multiSelectBox) return;
      var multiSelectBox = _this14.multiSelectBox;
      var topY = multiSelectBox.y;
      var bottomY = multiSelectBox.y + multiSelectBox.height;
      var leftX = multiSelectBox.x;
      var rightX = multiSelectBox.x + multiSelectBox.width;
      var fieldsToSelect = [];

      _this14.fields.forEach(function (field) {
        if (field.x < rightX && leftX < field.x + field.width && field.y < bottomY && topY < field.y + field.height) {
          fieldsToSelect.push(field);
        }
      });

      if (fieldsToSelect.length > 0) {
        _this14.pdfStore.setSelectedFields(fieldsToSelect);
      } else {
        _this14.pdfStore.setSelectedFields();
      }
    };
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "updateGhostFieldLocations", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this15 = this;

    return function (currentMouse) {
      var ghostFields = _this15.generateFields(currentMouse);

      _this15.setGhostFields(ghostFields);

      var onExistingField = _this15.fields.some(function (field) {
        return field.containsPoint({
          x: _this15.unScale(currentMouse.x),
          y: _this15.unScale(currentMouse.y),
          page: _this15.pageNumber
        });
      });

      var contextMenuOpen = _this15.pdfStore.contextMenu;
      if (onExistingField || contextMenuOpen) _this15.setGhostFields();
    };
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "updateSelectedFieldLocation", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this16 = this;

    return function (newFieldLocation) {
      var selectedFields = _this16.pdfStore.selectedFields;
      var field = selectedFields[0];

      var _this16$limitFieldPos = _this16.limitFieldPositionToPageBoundary({
        x: newFieldLocation.x,
        y: newFieldLocation.y
      }, field.width, field.height),
          x = _this16$limitFieldPos.x,
          y = _this16$limitFieldPos.y;

      field.updateAttributes({
        x: x,
        y: y
      });
    };
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "moveSelectedFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this17 = this;

    return function (offSet) {
      var _this$pdfStore$select5;

      (_this$pdfStore$select5 = _this17.pdfStore.selectedFields) === null || _this$pdfStore$select5 === void 0 ? void 0 : _this$pdfStore$select5.forEach(function (field) {
        var _this17$limitFieldPos = _this17.limitFieldPositionToPageBoundary({
          x: field.x + offSet.x,
          y: field.y + offSet.y
        }, field.width, field.height),
            x = _this17$limitFieldPos.x,
            y = _this17$limitFieldPos.y;

        field.updateAttributes({
          x: x,
          y: y
        });
      });
    };
  }
})), _class);
export default PdfPageStore;
export { positionComparator };